import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, Typography } from 'antd';
import cn from 'classnames';

import { useClientSearchOption } from '@app/components/RecordModal/components/RecordDetails/hooks/useClientSearchOption';
import type { RecordClientSearchResult } from '@app/components/RecordModal/components/RecordDetails/types';

import type { FC } from 'react';

import '@app/components/RecordModal/components/RecordDetails/styles/ClientSearchOption.scss';

interface ClientSearchOptionProps {
  client: RecordClientSearchResult;
  dataTestId?: string;
}

// Строка найденного клиента. Одна разметка у меню поля «Поиск» и у меню
// поля «Мобильный телефон» (task/11629).
export const ClientSearchOption: FC<ClientSearchOptionProps> = ({
  client,
  dataTestId = 'client-option',
}) => {
  const { name, genderIcon, isMale, isFemale, birthInfo } =
    useClientSearchOption(client);

  return (
    <div className="ClientSearchOption" data-testid={dataTestId}>
      <div className="ClientSearchOption__name">
        {name}
        {genderIcon && (
          <FontAwesomeIcon
            className={cn('ClientSearchOption__icon', {
              'ClientSearchOption__icon--male': isMale,
              'ClientSearchOption__icon--female': isFemale,
            })}
            icon={genderIcon}
          />
        )}
      </div>
      {birthInfo && (
        <Typography.Text className="ClientSearchOption__meta">
          {birthInfo}
        </Typography.Text>
      )}
      {client.Phone1 && (
        <div className="ClientSearchOption__phone">
          {client.IsPhoneVerified && (
            <Tooltip title="Номер подтвержден">
              <FontAwesomeIcon
                icon={faCircleCheck}
                className="ClientSearchOption__icon ClientSearchOption__icon--verified"
              />
            </Tooltip>
          )}
          <Typography.Text>+{client.Phone1}</Typography.Text>
        </div>
      )}
      {client.Phone2 && (
        <Typography.Text className="ClientSearchOption__meta">
          +{client.Phone2}
        </Typography.Text>
      )}
      {client.Email && (
        <Typography.Text className="ClientSearchOption__meta">
          {client.Email}
        </Typography.Text>
      )}
    </div>
  );
};
